import { AxiosClient } from "./AxiosClient";

// Dedicated OSINT map lane (see api/routes/map_api.py). BASE_URL already ends in
// /api/, so these resolve to /api/map/*.

export const getMapEventTypes = () => AxiosClient.get("map/event-types");

export const getMapEvents = (payload, config = {}) =>
  AxiosClient.post("map/events", payload, config);

export const getMapInfrastructure = (payload, config = {}) =>
  AxiosClient.post("map/infrastructure", payload, config);

// Just-in-time hover preview: presigned screenshot URL for one marker's post.
// Local-only on the server (never federates to the peer); screenshot may be null.
export const getMapDocPreview = (documentId, config = {}) =>
  AxiosClient.get("map/doc-preview", {
    params: { document_id: documentId },
    ...config,
  });

export const getMapRegions = (params = {}) =>
  AxiosClient.get("map/regions", { params });

export const getMapRegionPolygon = (areaId) =>
  AxiosClient.get(`map/regions/${encodeURIComponent(areaId)}/polygon`);

// Custom (user-drawn, lasso) regions.
export const suggestCustomRegion = (geometry) =>
  AxiosClient.post("map/regions/custom/suggest", { geometry });

export const createCustomRegion = (payload) =>
  AxiosClient.post("map/regions/custom", payload);

// Redraw a custom region in place (same id) — presets that reference it update
// automatically. Keeps the existing name unless payload includes a new one.
export const updateCustomRegion = (regionId, payload) =>
  AxiosClient.put(`map/regions/custom/${encodeURIComponent(regionId)}`, payload);

export const deleteCustomRegion = (regionId) =>
  AxiosClient.delete(`map/regions/custom/${encodeURIComponent(regionId)}`);

// Presets: named snapshots of the map's filter selections. getMapPresets returns
// { fixed: [...], user: [...] }; the rest are per-user CRUD.
export const getMapPresets = () => AxiosClient.get("map/presets");

// Contextual bottom panel, driven by the current map filter (target_types + regions
// + timeframe): media = the screenshot reel; stats = the charts + KPIs.
export const getMapPanelMedia = (payload, config = {}) =>
  AxiosClient.post("map/panel/media", payload, config);

export const getMapPanelStats = (payload, config = {}) =>
  AxiosClient.post("map/panel/stats", payload, config);

// Resolve the dynamic "Trending" preset to a live filter state + hotspots
// (server-computed, cached ~15 min). mode: "surging" | "volume" | "hybrid".
export const getTrendingPreset = (mode) =>
  AxiosClient.get("map/presets/trending", {
    params: mode ? { mode } : {},
  });

export const createMapPreset = (payload) =>
  AxiosClient.post("map/presets", payload);

export const updateMapPreset = (presetId, payload) =>
  AxiosClient.put(`map/presets/${encodeURIComponent(presetId)}`, payload);

export const deleteMapPreset = (presetId) =>
  AxiosClient.delete(`map/presets/${encodeURIComponent(presetId)}`);
